import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';

import ReadingsHelpers from 'utils/ReadingsHelpers';
import { useTranslation } from 'react-i18next';

const MobileSurfaceGridCell = ({ surfaceDataType, value, convertTemp, convertPPM, convertUnits }) => {
  let convert = false;
  const { t } = useTranslation();

  convert = ReadingsHelpers.getNeedsConversion(surfaceDataType, convertPPM, convertTemp, convertUnits);
  const display = ReadingsHelpers.displayReading(surfaceDataType, value, false, false, convert);

  const units = ReadingsHelpers.getUnitsForReading(surfaceDataType, convert);

  return (
    <Grid container item xs={12} key={Math.random() * 10000}>
      {value ? (
        <Grid container item xs={12} key={Math.random() * 10000}>
          <Grid item container xs={6} key={Math.random() * 10000}>
            <Grid item xs={12} key={Math.random() * 10000}>
              <Typography align="center" variant="subtitle2" key={Math.random() * 10000}>
                {t(surfaceDataType)}
              </Typography>
            </Grid>
          </Grid>

          <Grid container item xs={6} key={Math.random() * 10000}>
            <Grid item xs={6} key={Math.random() * 10000}>
              <Typography align="right" key={Math.random() * 10000} variant="h5">
                {display}
              </Typography>
            </Grid>
            <Grid item xs={6} key={Math.random() * 10000}>
              <Typography align="left" variant="subtitle2" key={Math.random() * 10000} style={{ paddingLeft: 5 }}>
                {units}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

MobileSurfaceGridCell.propTypes = {
  surfaceDataType: PropTypes.string,
  value: PropTypes.array,
  convertTemp: PropTypes.bool,
  convertPPM: PropTypes.bool,
  convertUnits: PropTypes.bool,
};

MobileSurfaceGridCell.defaultProps = {
  surfaceDataType: '',
  value: [],
  convertTemp: false,
  convertPPM: false,
  convertUnits: false,
};

export default MobileSurfaceGridCell;
